export class EmployeeUserModel {
    constructor() {
        this.employeeId = "";
        this.emailId = "";
        this.roleId = [];
    }
}
export default class EmployeeUser extends EmployeeUserModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
